/* LJA refonte 2026 — comportements globaux des vignettes produit.
   Barre coulissante des photos swipeables (pattern pdpaola) : un seul écouteur
   délégué en phase capture, les événements scroll ne remontant pas autrement. */
(function () {
  document.addEventListener('scroll', function (e) {
    var strip = e.target;
    if (!(strip instanceof Element) || !strip.hasAttribute('data-lja-strip')) return;
    var thumb = strip.parentElement.querySelector('[data-lja-thumb]');
    if (!thumb) return;
    var max = strip.scrollWidth - strip.clientWidth;
    if (max <= 0) return;
    var n = Math.round(strip.scrollWidth / strip.clientWidth);
    thumb.style.transform = 'translateX(' + ((strip.scrollLeft / max) * (n - 1) * 100).toFixed(2) + '%)';
  }, { capture: true, passive: true });
})();

/* Shop the look (atelier 10/07) : la photo pleine largeur ouvre une feuille bas
   avec les bijoux du look. L'ajout au panier (data-look-add) est géré par le
   tiroir panier, qui appelle window.ljaCloseLook() après l'ajout. */
(function () {
  function closeAll() {
    document.querySelectorAll('.lja-clook__sheet.on').forEach(function (s) { s.classList.remove('on'); });
    var sc = document.getElementById('lja-look-scrim');
    if (sc) sc.classList.remove('on');
    document.body.style.overflow = '';
  }
  window.ljaCloseLook = closeAll;
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-look-open]');
    if (o) {
      e.preventDefault();
      var s = document.getElementById('look-' + o.getAttribute('data-look-open'));
      if (!s) return;
      s.classList.add('on');
      var sc = document.getElementById('lja-look-scrim');
      if (sc) sc.classList.add('on');
      document.body.style.overflow = 'hidden';
      return;
    }
    if (e.target.closest && e.target.closest('[data-look-close]')) { closeAll(); return; }
    if (e.target.id === 'lja-look-scrim') closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();

/* Pastilles couleur réelles sur les vignettes (arbitrage 10/07) : le clic bascule
   photo, prix, lien de la carte et variante du bouton panier, sans quitter la page.
   Les données (variante, image, prix, url) sont portées par la pastille (data-sw-*). */
(function () {
  function applySwatch(sw) {
    var card = sw.closest('.lja-card');
    if (!card) return;
    card.querySelectorAll('.lja-card__sw i').forEach(function (i) { i.classList.remove('sel'); });
    sw.classList.add('sel');
    // photo : 1re slide de la bande, sinon l'image seule du cadre
    var img = card.querySelector('.lja-card__strip .lja-card__slide img') || card.querySelector('.lja-card__ph > img');
    var src = sw.getAttribute('data-sw-img');
    if (img && src) {
      img.src = src;
      img.srcset = sw.getAttribute('data-sw-srcset') || '';
    }
    var strip = card.querySelector('[data-lja-strip]');
    if (strip) strip.scrollLeft = 0;
    // lien de la carte (la carte EST le <a>)
    var url = sw.getAttribute('data-sw-url');
    if (url) card.setAttribute('href', url);
    // prix (peut porter un barré <s>, généré par notre liquid)
    var pr = card.querySelector('.lja-card__pr');
    var price = sw.getAttribute('data-sw-price');
    if (pr && price) pr.innerHTML = price;
    // bouton panier : suit la variante ; masqué si la couleur est épuisée
    var btn = card.querySelector('[data-card-add]');
    if (btn) {
      btn.setAttribute('data-card-add', sw.getAttribute('data-sw-variant') || '');
      btn.hidden = sw.getAttribute('data-sw-avail') === 'false';
    }
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.lja-card__sw--live [data-sw-variant]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    applySwatch(sw);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = e.target.closest && e.target.closest('.lja-card__sw--live [data-sw-variant]');
    if (!sw) return;
    e.preventDefault();
    applySwatch(sw);
  });
})();

/* Focus trap réutilisable pour les tiroirs (dialogue modal accessible au clavier).
   Usage : var release = window.ljaTrapFocus(panneau) à l'ouverture, release() à la fermeture
   (rend aussi le focus à l'élément qui avait ouvert le tiroir). */
window.ljaTrapFocus = function (panel) {
  var lastFocus = document.activeElement;
  function onKey(e) {
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('keydown', onKey, true);
  if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
  panel.focus({ preventScroll: true });
  return function () {
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
};

/* Wishlist locale « Mes favoris » : cœurs sur vignettes et fiche, tiroir dans le header.
   Mémorisée dans le navigateur (localStorage), comme les « Vus récemment ». */
(function () {
  var KEY = 'lja:wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(ids) {
    try { localStorage.setItem(KEY, JSON.stringify(ids.slice(0, 60))); } catch (e) {}
    refresh();
  }
  function refresh() {
    var ids = read();
    document.querySelectorAll('[data-lja-wish]').forEach(function (h) {
      h.classList.toggle('on', ids.indexOf(parseInt(h.dataset.ljaWish, 10)) > -1);
    });
    var count = document.querySelector('[data-lja-wish-count]');
    if (count) { count.hidden = ids.length === 0; count.textContent = ids.length; }
    var title = document.querySelector('[data-lja-wish-count-title]');
    if (title) title.textContent = ids.length ? '(' + ids.length + ')' : '';
  }

  // Les cœurs sont des role="button" : Enter/Espace doivent les actionner comme un clic.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var h = e.target && e.target.closest && e.target.closest('[data-lja-wish]');
    if (!h) return;
    e.preventDefault();
    h.click();
  });

  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-lja-wish]');
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    var id = parseInt(h.dataset.ljaWish, 10);
    var ids = read();
    var i = ids.indexOf(id);
    if (i > -1) ids.splice(i, 1); else ids.unshift(id);
    write(ids);
    // dans le tiroir : retirer la carte immédiatement
    var drawer = h.closest('.lja-wdrawer');
    if (drawer && i > -1) {
      var card = h.closest('.lja-witem') || h.closest('.lja-card');
      if (card) card.remove();
      if (!drawer.querySelector('.lja-card')) showEmpty(true);
    }
  });

  var drawer = null, scrim = null, untrap = null;
  function showEmpty(yes) {
    var empty = document.querySelector('[data-lja-wish-empty]');
    if (empty) empty.hidden = !yes;
  }
  function setExpanded(on) {
    document.querySelectorAll('[data-lja-wish-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function openDrawer() {
    drawer = drawer || document.getElementById('lja-wish-drawer');
    scrim = scrim || document.getElementById('lja-wish-scrim');
    if (!drawer) return;
    drawer.classList.add('open');
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    setExpanded(true);
    if (window.ljaTrapFocus) untrap = window.ljaTrapFocus(drawer);
    var grid = drawer.querySelector('[data-lja-wish-grid]');
    var ids = read();
    grid.innerHTML = '';
    showEmpty(ids.length === 0);
    if (!ids.length) return;
    var q = ids.slice(0, 24).map(function (i) { return 'id:' + i; }).join(' OR ');
    fetch('/search?view=wish&type=product&q=' + encodeURIComponent(q))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        grid.innerHTML = html;
        showEmpty(!grid.querySelector('.lja-card'));
        refresh();
      })
      .catch(function () { showEmpty(true); });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    document.body.style.overflow = '';
    setExpanded(false);
    if (untrap) { untrap(); untrap = null; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lja-wish-open]')) openDrawer();
    if (e.target.closest('[data-lja-wish-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();

/* Beacon des recherches : alimente le menu « recherches populaires » (recalculé chaque
   semaine côté serveur). Fire-and-forget, anonyme (le terme et rien d'autre), dédoublonné
   par session. Corps text/plain = requête CORS « simple », pas de préflight. */
(function () {
  var ENDPOINT = 'https://chat.lja-studio.fr/search-log';
  var seen;
  try { seen = JSON.parse(sessionStorage.getItem('lja:sq') || '[]'); } catch (e) { seen = []; }

  function send(q) {
    q = (q || '').replace(/\s+/g, ' ').trim();
    if (q.length < 3 || q.length > 80) return;
    var k = q.toLowerCase();
    if (seen.indexOf(k) > -1) return;
    seen.push(k);
    try { sessionStorage.setItem('lja:sq', JSON.stringify(seen.slice(-30))); } catch (e) {}
    try {
      var body = JSON.stringify({ q: q });
      if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }));
      else fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: true });
    } catch (e) {}
  }

  // Page de résultats : la recherche a été soumise.
  if (location.pathname.indexOf('/search') === 0) {
    try { var q = new URLSearchParams(location.search).get('q'); if (q) send(q); } catch (e) {}
  }

  // Tiroir prédictif : saisie stabilisée 2 s = intention de recherche (couvre aussi les
  // sorties par clic direct sur un produit suggéré, qui ne passent jamais par /search).
  var t;
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('.predictive-search__input')) return;
    clearTimeout(t);
    t = setTimeout(function () { send(el.value); }, 2000);
  }, true);
})();
